<template>
  <modal
    :class="['overlay', name]"
    :name="name"
    :max-width="maxWidth"
    :shift-y="$device.mobile ? 0.9 : 0.5"
    :adaptive="true"
    height="auto"
    width="95%"
    :reset="true"
    :click-to-close="clickToClose"
    @closed="close"
    @before-open="onBeforeOpen"
    @before-close="onBeforeClose"
  >
    <div :class="['b-modal', modalClass]">
      <div :class="{ 'no-title': !title }" class="modal-head">
        <span class="title">{{ title }}</span>
        <i
          v-if="clickToClose"
          class="bx bx-x modal-close-icon modal-icon"
          @click="hideThisModal"
        ></i>
        <i v-if="goBack" class="bx bx-arrow-back modal-back-icon modal-icon" @click="goBack"></i>
      </div>
      <div class="modal-body">
        <slot />
      </div>
      <div v-if="$slots.footer" class="modal-footer">
        <slot name="footer" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: () => ''
    },
    titleClass: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: () => ''
    },
    maxWidth: {
      type: Number,
      default: () => 400
    },
    pivotY: {
      type: Number,
      default: () => 0.5
    },
    modalClass: {
      type: String,
      default: () => ''
    },
    goBack: {
      type: Function,
      default: null
    },
    subTitleClass: {
      type: String,
      default: () => ''
    },
    onClose: {
      type: Function,
      default: () => null
    },
    closeCallBack: {
      type: Function,
      default: () => null
    },
    beforeOpen: {
      type: Function,
      default: () => null
    },
    beforeClose: {
      type: Function,
      default: () => null
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    clickToClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    hideThisModal() {
      this.onClose()
      this.$modal.hide(this.name)
    },
    onBeforeOpen(e) {
      if (this.lockScroll) this.$scroll.lock()
      this.beforeOpen(e)
    },
    onBeforeClose(e) {
      if (this.lockScroll) this.$scroll.unlock()
      this.beforeClose(e)
    },
    close() {
      this.onClose()
      this.closeCallBack()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_local-variables.scss';
.modal-head {
  width: 100%;
  padding: 16px 54px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid $color-neutral-200;
  .title {
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* количество строк */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.no-title {
    border: none;
    padding: 0 54px;
  }
  span {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
  }
  .modal-close-icon {
    position: absolute;
    right: 16px;
    top: 18px;
    z-index: 5;
    cursor: pointer;
  }
  .modal-back-icon {
    position: absolute;
    left: 16px;
    top: 18px;
    cursor: pointer;
  }
}

.modal-body {
  padding: 56px 16px 42px;
  max-height: 70vh;
  overflow-y: auto;
  position: relative;
  @media (max-width: 768px) {
    padding: 16px;
  }
}
.overlay {
  background: rgba(0, 0, 0, 0.75);
  z-index: 9999999999;
  & ::v-deep {
    .vm--modal {
      border-radius: 10px;
    }
  }
}
</style>
<style lang="scss">
.vm--modal-overlay {
  padding: 20px 0;
  max-height: 100vh;
  overflow-y: auto;
  & ::v-deep .vm--modal {
    @media (max-width: 560px) {
      top: 0 !important;
    }
  }
}
.vm--modal-overlay.scrollable::-webkit-scrollbar {
  display: none;
}
</style>
